module.exports = __webpack_public_path__ + "assets/img/ic-game.878146cd.svg";